import { render, staticRenderFns } from "./AdvertisingItem.vue?vue&type=template&id=409a4481"
import script from "./AdvertisingItem.vue?vue&type=script&lang=js"
export * from "./AdvertisingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports